export default "__VITE_ASSET__108273f4__"